import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPersist from 'pinia-plugin-persist';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import router from './routes';

// global validation rules
import { defineRule } from 'vee-validate';
import * as AllRules from '@vee-validate/rules';


// styles
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";
import excel from 'vue-excel-export'
import XLSX from 'xlsx'

// mouting point for the whole app
import App from "@/App.vue";

const pinia = createPinia();
pinia.use(piniaPersist);

Object.keys(AllRules).forEach(rule => {
  defineRule(rule, AllRules[rule]);
});

const app = createApp(App);

app.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
});
app.use(pinia);
app.use(router);
app.use(excel)
app.use(XLSX)

app.mount("#app");
